// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notice-default[data-v-162ff93b]{display:block;height:100%;text-decoration:none;color:inherit}.notice-default .notice-default__title[data-v-162ff93b]{color:#00afa1}.notice-default .notice-default__text[data-v-162ff93b],.notice-default .notice-default__title[data-v-162ff93b]{word-break:break-word}", ""]);
// Exports
module.exports = exports;
